document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-mobile-menu]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var nav = document.querySelector('[data-main-nav]');
      if(!nav) return;

      nav.classList.toggle('is-open');

      document.body.classList.toggle(
        'menu-open',
        nav.classList.contains('is-open')
      );

      btn.setAttribute(
        'aria-expanded',
        nav.classList.contains('is-open') ? 'true' : 'false'
      );
    });
  });

  document.querySelectorAll('[data-submenu-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){

      var item = btn.closest('[data-nav-item]');
      if(!item) return;

      var isOpen = item.classList.contains('is-open');

      document.querySelectorAll('[data-nav-item]').forEach(function(other){
        if(other !== item){
          other.classList.remove('is-open');

          var otherBtn = other.querySelector('[data-submenu-toggle]');
          if(otherBtn){
            otherBtn.setAttribute('aria-expanded', 'false');
          }
        }
      });

      item.classList.toggle('is-open', !isOpen);

      btn.setAttribute(
        'aria-expanded',
        !isOpen ? 'true' : 'false'
      );
    });
  });

  document.querySelectorAll('[data-filter-details]').forEach(function(detail){
    detail.addEventListener('toggle', function(){
      if(!detail.open) return;

      document.querySelectorAll('[data-filter-details]').forEach(function(other){
        if(other !== detail){
          other.removeAttribute('open');
        }
      });
    });
  });
document.querySelectorAll('[data-product-thumb]').forEach(function(button){
  button.addEventListener('click', function(){
    var mainImage = document.getElementById('ProductMainImage');
    if(!mainImage) return;

    mainImage.src = button.getAttribute('data-image');

    document.querySelectorAll('[data-product-thumb]').forEach(function(other){
      other.classList.remove('is-active');
    });

    button.classList.add('is-active');
  });
});
});